export const tableBlock = `
_type == 'tableBlock' => {
  "informations": informations[_key == $lang][0].value,
  lines[] {
    ...,
    "line": line[_key == $lang][0].value,
  }
}
`
